import CtnEditModal from './CtnEditModal';

export default CtnEditModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ctnEdit/index.jsx